module.exports = __webpack_public_path__ + "static/media/Done-erx.febe9754.svg";